import React, { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Tokenomics = () => {
  const container = useRef();

  useGSAP(() => {
    gsap.from(".token-stat", {
      y: 50,
      opacity: 0,
      duration: 0.6,
      stagger: 0.05,
      ease: "power2.out",
      scrollTrigger: {
        trigger: container.current,
        start: "top 85%",
        toggleActions: "play none none reverse"
      }
    });

    gsap.from(".chart-img", {
      scale: 0.8,
      opacity: 0,
      duration: 0.8,
      stagger: 0.15,
      ease: "power4.out",
      scrollTrigger: {
        trigger: ".chart-container",
        start: "top 70%",
      }
    });
  }, { scope: container });

  return (
    <div id="tokenomics" ref={container} className="text-center lg:py-32 py-20 lg:px-10 px-5 bg-slate-900/50">
      <h1 className="lg:text-3xl text-2xl font-bold lg:mb-20 mb-10 text-transparent bg-clip-text bg-gradient-to-r from-violet-500 to-fuchsia-500">
        Tokenomics
      </h1>
      <div className="flex flex-wrap justify-center gap-20">
        <div className="grid grid-cols-[1fr,10px,1fr] gap-x-6 gap-y-4 text-left text-lg">
            <p className="token-stat font-semibold">Name</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300">AI GEN</p>
            <p className="token-stat font-semibold">Total Supply</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300">1B</p>
            <p className="token-stat font-semibold">Contract</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300 truncate w-40">0x...LoremIpsum</p>
        </div>
        <div className="grid grid-cols-[1fr,10px,1fr] gap-x-6 gap-y-4 text-left text-lg">
            <p className="token-stat font-semibold">Token Name</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300">$AIGEN</p>
            <p className="token-stat font-semibold">Circulating Supply</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300">1B</p>
            <p className="token-stat font-semibold">Chain</p>
            <p className="token-stat">:</p>
            <p className="token-stat text-slate-300">Ethereum</p>
        </div>
      </div>
      <div className="chart-container flex flex-col md:flex-row justify-center items-center p-10 gap-16 mt-20">
        <img src="/Donut.png" alt="Donut Chart" className="chart-img w-full md:w-[45%] drop-shadow-2xl" />
        <img src="/Holder.png" alt="Holder Chart" className="chart-img w-full md:w-[40%] drop-shadow-2xl" />
      </div>
    </div>
  );
};

export default Tokenomics;
